module.exports = __webpack_public_path__ + "static/img/loadding_pc.7145049.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loadding_pc.gif
// module id = WBaz
// module chunks = 10